const DrawflowModule = require('drawflow');
const Drawflow = DrawflowModule && DrawflowModule.default ? DrawflowModule.default : DrawflowModule;

const STATUS_LABEL_CLASS = {
    in_attesa: 'label-default',
    in_corso: 'label-warning',
    completato: 'label-success',
};

function csrfToken() {
    return $('meta[name="csrf-token"]').attr('content');
}

function escapeHtml(value) {
    return $('<div>').text(value == null ? '' : String(value)).html();
}

function routeWithId(template, id) {
    return String(template).replace('__ID__', id);
}

const WorkingBlocksCanvas = {
    editor: null,
    config: null,
    initialized: false,
    loading: false,
    suppressConnectionEvents: false,
    sheetToNode: {},
    nodeToSheet: {},
    blocks: {},
    connectionIds: {},
    statuses: [],
    availableDivisions: [],
    defaultDivisionId: null,
    canModify: false,

    connectionKey(from, to) {
        return from + '->' + to;
    },

    init(containerId) {
        const config = window.__workingBlocksConfig;
        if (!config || typeof Drawflow !== 'function') {
            return;
        }

        const container = document.getElementById(containerId);
        if (!container) {
            return;
        }

        if (this.initialized) {
            return;
        }
        this.initialized = true;
        this.config = config;

        this.editor = new Drawflow(container);
        this.editor.reroute = true;
        this.editor.editor_mode = config.canModify ? 'edit' : 'view';
        this.editor.start();

        this.bindEditorEvents();
        this.bindDomEvents(container);
        this.loadCanvas();
    },

    bindEditorEvents() {
        const self = this;

        this.editor.on('nodeMoved', (nodeId) => {
            if (self.loading || !self.canModify) {
                return;
            }
            self.persistPosition(nodeId);
        });

        this.editor.on('connectionCreated', (info) => {
            if (self.loading || self.suppressConnectionEvents) {
                return;
            }
            self.handleConnectionCreated(info);
        });

        this.editor.on('connectionRemoved', (info) => {
            if (self.loading || self.suppressConnectionEvents) {
                return;
            }
            self.handleConnectionRemoved(info);
        });

        // Persiste l'eliminazione del blocco: copre sia il pulsante "elimina" del nodo
        // sia la cancellazione nativa di Drawflow (menu contestuale / tasto Canc).
        this.editor.on('nodeRemoved', (nodeId) => {
            if (self.loading) {
                return;
            }
            self.handleNodeRemoved(nodeId);
        });
    },

    bindDomEvents(container) {
        const self = this;
        const $container = $(container);

        // Evita che i click sui controlli avviino il drag del nodo.
        $container.on('mousedown', '.wb-node-control', function (e) {
            e.stopPropagation();
        });

        $container.on('change', '.wb-status-select', function (e) {
            e.stopPropagation();
            const sheetId = parseInt($(this).data('sheet-id'), 10);
            self.changeStatus(sheetId, $(this).val(), this);
        });

        $container.on('change', '.wb-division-select', function (e) {
            e.stopPropagation();
            const sheetId = parseInt($(this).data('sheet-id'), 10);
            const value = $(this).val();
            self.changeDivision(sheetId, value ? parseInt(value, 10) : null);
        });

        $container.on('dblclick', '.wb-node-header', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!self.canModify) {
                return;
            }
            const sheetId = parseInt($(this).closest('.wb-node').data('sheet-id'), 10);
            if (sheetId) {
                self.renameBlock(sheetId);
            }
        });

        $container.on('click', '.wb-edit-dates', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const sheetId = parseInt($(this).data('sheet-id'), 10);
            self.openDatesModal(sheetId);
        });

        $container.on('click', '.wb-delete-block', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const sheetId = parseInt($(this).data('sheet-id'), 10);
            self.confirmDeleteBlock(sheetId);
        });

        // Il pulsante "Nuovo Working Block" vive nella toolbar, fuori dal container canvas.
        $(document).off('click.wbAddBlock', '.wb-add-block-btn').on('click.wbAddBlock', '.wb-add-block-btn', function (e) {
            e.preventDefault();
            self.addBlock();
        });
    },

    loadCanvas() {
        const self = this;
        $.ajax({
            url: this.config.canvasUrl,
            method: 'GET',
            success(response) {
                if (!response || !response.success) {
                    return;
                }
                self.canModify = !!response.can_modify;
                self.statuses = response.statuses || [];
                self.availableDivisions = response.available_divisions || [];
                self.defaultDivisionId = response.default_division_id || null;
                self.editor.editor_mode = self.canModify ? 'edit' : 'view';
                self.renderGraph(response.blocks || [], response.connections || []);
            },
            error() {
                console.error('Errore nel caricamento della canvas dei Working Block');
            },
        });
    },

    renderGraph(blocks, connections) {
        this.loading = true;
        this.sheetToNode = {};
        this.nodeToSheet = {};
        this.blocks = {};
        this.connectionIds = {};

        let autoX = 60;
        const autoY = 80;

        blocks.forEach((block, index) => {
            this.blocks[block.id] = block;
            const posX = Number.isFinite(block.canvas_x) && block.canvas_x !== null ? block.canvas_x : autoX + (index * 280);
            const posY = Number.isFinite(block.canvas_y) && block.canvas_y !== null ? block.canvas_y : autoY;

            const nodeId = this.editor.addNode(
                'working_block',
                1,
                1,
                posX,
                posY,
                'working-block',
                { sheetId: block.id },
                this.buildNodeHtml(block),
                false
            );

            this.sheetToNode[block.id] = nodeId;
            this.nodeToSheet[nodeId] = block.id;
        });

        connections.forEach((conn) => {
            const fromNode = this.sheetToNode[conn.from];
            const toNode = this.sheetToNode[conn.to];
            if (!fromNode || !toNode) {
                return;
            }
            this.connectionIds[this.connectionKey(conn.from, conn.to)] = conn.id;
            this.editor.addConnection(fromNode, toNode, 'output_1', 'input_1');
        });

        this.loading = false;
    },

    buildNodeHtml(block) {
        const statusClass = STATUS_LABEL_CLASS[block.status] || 'label-default';

        let divisionHtml;
        if (this.canModify) {
            const options = ['<option value="">— Nessuna divisione —</option>'].concat(
                (this.availableDivisions || []).map((d) => {
                    const selected = block.division_id && String(d.id) === String(block.division_id) ? ' selected' : '';
                    return '<option value="' + d.id + '"' + selected + '>' + escapeHtml(d.name) + '</option>';
                })
            ).join('');
            divisionHtml = '<div class="wb-division">' +
                '<i class="fa fa-sitemap"></i> ' +
                '<select class="form-control input-sm wb-node-control wb-division-select" data-sheet-id="' + block.id + '">' + options + '</select>' +
                '</div>';
        } else {
            const label = block.division_name
                ? '<span class="wb-division-name"><i class="fa fa-sitemap"></i> ' + escapeHtml(block.division_name) + '</span>'
                : '<span class="wb-division-name wb-division-empty">Nessuna divisione</span>';
            divisionHtml = '<div class="wb-division">' + label + '</div>';
        }

        let statusControl = '<span class="label ' + statusClass + ' wb-status-badge">' + escapeHtml(block.status_label) + '</span>';
        if (this.canModify) {
            const options = this.statuses.map((s) => {
                const selected = s.value === block.status ? ' selected' : '';
                return '<option value="' + escapeHtml(s.value) + '"' + selected + '>' + escapeHtml(s.label) + '</option>';
            }).join('');
            statusControl = '<select class="form-control input-sm wb-node-control wb-status-select" data-sheet-id="' + block.id + '">' + options + '</select>';
        }

        let datesButton = '';
        let deleteButton = '';
        if (this.canModify) {
            datesButton = '<button type="button" class="btn btn-xs btn-default wb-node-control wb-edit-dates" data-sheet-id="' + block.id + '" title="Imposta date"><i class="fa fa-calendar"></i></button>';
            deleteButton = '<button type="button" class="btn btn-xs btn-danger wb-node-control wb-delete-block" data-sheet-id="' + block.id + '" title="Elimina Working Block"><i class="fa fa-trash"></i></button>';
        }

        const startBadge = block.start_date_label
            ? '<span class="wb-start-date label label-info" title="Data di inizio"><i class="fa fa-play"></i> ' + escapeHtml(block.start_date_label) + '</span>'
            : '';

        let dueBadge = '';
        if (block.due_date_label) {
            const overdue = block.due_date && block.status !== 'completato' && block.due_date < this.today();
            const dueClass = overdue ? 'label-danger' : 'label-default';
            dueBadge = '<span class="wb-due-date label ' + dueClass + '" title="Data di scadenza"><i class="fa fa-flag-checkered"></i> ' + escapeHtml(block.due_date_label) + '</span>';
        }

        return '' +
            '<div class="wb-node-wrap">' +
                startBadge +
                '<div class="wb-node wb-status-' + escapeHtml(block.status) + '" data-sheet-id="' + block.id + '">' +
                    '<div class="wb-node-header' + (this.canModify ? ' wb-node-header-editable' : '') + '"' +
                        (this.canModify ? ' title="Doppio click per rinominare"' : '') + '>' +
                        '<span class="wb-node-title">' + escapeHtml(block.name) + '</span>' +
                    '</div>' +
                    '<div class="wb-node-body">' +
                        divisionHtml +
                        '<div class="wb-node-meta">' +
                            '<span class="wb-task-count"><i class="fa fa-tasks"></i> ' + (block.task_count || 0) + ' task</span>' +
                            datesButton +
                            deleteButton +
                        '</div>' +
                    '</div>' +
                    '<div class="wb-node-footer">' + statusControl + '</div>' +
                '</div>' +
                dueBadge +
            '</div>';
    },

    today() {
        const d = new Date();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return d.getFullYear() + '-' + m + '-' + day;
    },

    refreshNode(block) {
        this.blocks[block.id] = block;
        const nodeId = this.sheetToNode[block.id];
        if (!nodeId) {
            return;
        }
        const html = this.buildNodeHtml(block);
        if (this.editor.drawflow.drawflow.Home.data[nodeId]) {
            this.editor.drawflow.drawflow.Home.data[nodeId].html = html;
        }
        const nodeElement = document.querySelector('#node-' + nodeId + ' .drawflow_content_node');
        if (nodeElement) {
            nodeElement.innerHTML = html;
        }
    },

    persistPosition(nodeId) {
        const sheetId = this.nodeToSheet[nodeId];
        if (!sheetId) {
            return;
        }
        const node = this.editor.getNodeFromId(nodeId);
        if (!node) {
            return;
        }
        $.ajax({
            url: routeWithId(this.config.routes.position, sheetId),
            method: 'PUT',
            data: {
                canvas_x: Math.round(node.pos_x),
                canvas_y: Math.round(node.pos_y),
                _token: csrfToken(),
            },
        });
    },

    changeStatus(sheetId, status, selectEl) {
        const self = this;
        $.ajax({
            url: routeWithId(this.config.routes.status, sheetId),
            method: 'PUT',
            data: { status: status, _token: csrfToken() },
            success(response) {
                if (response && response.success && response.block) {
                    self.refreshNode(response.block);
                }
            },
            error(xhr) {
                const msg = xhr.responseJSON?.errors?.status
                    ? xhr.responseJSON.errors.status[0]
                    : (xhr.responseJSON?.message || 'Impossibile aggiornare lo stato.');
                window.Swal && window.Swal.fire({ icon: 'error', title: 'Operazione non consentita', text: msg });
                // Ripristina il valore precedente nel select.
                const block = self.blocks[sheetId];
                if (block && selectEl) {
                    $(selectEl).val(block.status);
                }
            },
        });
    },

    handleConnectionCreated(info) {
        const self = this;
        const fromSheet = this.nodeToSheet[parseInt(info.output_id, 10)];
        const toSheet = this.nodeToSheet[parseInt(info.input_id, 10)];
        if (!fromSheet || !toSheet) {
            return;
        }

        $.ajax({
            url: this.config.routes.connectionStore,
            method: 'POST',
            data: { from: fromSheet, to: toSheet, _token: csrfToken() },
            success(response) {
                if (response && response.success && response.connection) {
                    self.connectionIds[self.connectionKey(fromSheet, toSheet)] = response.connection.id;
                }
            },
            error(xhr) {
                const msg = xhr.responseJSON?.errors?.to
                    ? xhr.responseJSON.errors.to[0]
                    : (xhr.responseJSON?.message || 'Connessione non valida.');
                window.Swal && window.Swal.fire({ icon: 'error', title: 'Connessione rifiutata', text: msg });
                self.removeConnectionFromEditor(info);
            },
        });
    },

    handleConnectionRemoved(info) {
        const self = this;
        const fromSheet = this.nodeToSheet[parseInt(info.output_id, 10)];
        const toSheet = this.nodeToSheet[parseInt(info.input_id, 10)];
        if (!fromSheet || !toSheet) {
            return;
        }
        const key = this.connectionKey(fromSheet, toSheet);
        const connectionId = this.connectionIds[key];
        if (!connectionId) {
            return;
        }
        $.ajax({
            url: routeWithId(this.config.routes.connectionDestroy, connectionId),
            method: 'DELETE',
            data: { _token: csrfToken() },
            success() {
                delete self.connectionIds[key];
            },
        });
    },

    removeConnectionFromEditor(info) {
        this.suppressConnectionEvents = true;
        try {
            this.editor.removeSingleConnection(info.output_id, info.input_id, info.output_class, info.input_class);
        } catch (e) {
            // ignore
        }
        this.suppressConnectionEvents = false;
    },

    changeDivision(sheetId, divisionId) {
        const self = this;
        $.ajax({
            url: routeWithId(this.config.routes.division, sheetId),
            method: 'PUT',
            data: { division_id: divisionId, _token: csrfToken() },
            success(response) {
                if (response && response.success && response.block) {
                    self.refreshNode(response.block);
                }
            },
            error() {
                window.Swal && window.Swal.fire({ icon: 'error', title: 'Errore', text: 'Impossibile aggiornare la divisione.' });
            },
        });
    },

    renameBlock(sheetId) {
        const self = this;
        const block = this.blocks[sheetId];
        if (!block || !this.config.routes.update || !window.Swal) {
            return;
        }

        window.Swal.fire({
            title: 'Rinomina Working Block',
            input: 'text',
            inputValue: block.name || '',
            inputPlaceholder: 'Nome Working Block',
            showCancelButton: true,
            confirmButtonText: 'Salva',
            cancelButtonText: 'Annulla',
            inputValidator: (value) => {
                if (!value || !value.trim()) {
                    return 'Inserisci un nome';
                }
                return null;
            },
        }).then((result) => {
            if (!result.isConfirmed || !result.value) {
                return;
            }
            const name = result.value.trim();
            if (name === block.name) {
                return;
            }
            $.ajax({
                url: routeWithId(self.config.routes.update, sheetId),
                method: 'PUT',
                data: { name: name, _token: csrfToken() },
                success(response) {
                    if (!response || !response.success) {
                        return;
                    }
                    block.name = (response.sheet && response.sheet.name) ? response.sheet.name : name;
                    self.refreshNode(block);
                    if (window.__taskSheetLabels) {
                        window.__taskSheetLabels[String(block.id)] = block.name;
                    }
                },
                error(xhr) {
                    const msg = (xhr.responseJSON?.errors?.name ? xhr.responseJSON.errors.name[0] : null)
                        || xhr.responseJSON?.message
                        || 'Errore durante la rinomina del Working Block';
                    window.Swal.fire({ icon: 'error', title: 'Errore', text: msg });
                },
            });
        });
    },

    openDatesModal(sheetId) {
        const self = this;
        const block = this.blocks[sheetId];
        if (!block || !this.config.routes.dates || !window.Swal) {
            return;
        }

        const startVal = block.start_date || '';
        const dueVal = block.due_date || '';

        window.Swal.fire({
            title: 'Date: ' + block.name,
            html: '<div style="text-align:left;">' +
                '<label style="display:block;margin:4px 0 2px;font-weight:600;">Data di inizio</label>' +
                '<input type="date" id="wb-start-date" class="swal2-input" style="margin:0;width:100%;">' +
                '<label style="display:block;margin:12px 0 2px;font-weight:600;">Data di scadenza</label>' +
                '<input type="date" id="wb-due-date" class="swal2-input" style="margin:0;width:100%;">' +
                '<p style="margin:10px 0 0;color:#888;font-size:12px;">Lascia vuoto per non impostare la data.</p>' +
                '</div>',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Salva',
            cancelButtonText: 'Annulla',
            didOpen: () => {
                // Valorizza esplicitamente: vuoto se la data non e impostata (niente "oggi" di default).
                const startEl = document.getElementById('wb-start-date');
                const dueEl = document.getElementById('wb-due-date');
                if (startEl) {
                    startEl.value = startVal;
                }
                if (dueEl) {
                    dueEl.value = dueVal;
                }
            },
            preConfirm: () => {
                const start = document.getElementById('wb-start-date').value || null;
                const due = document.getElementById('wb-due-date').value || null;
                if (start && due && due < start) {
                    window.Swal.showValidationMessage('La scadenza non puo precedere l\'inizio');
                    return false;
                }
                return { start_date: start, due_date: due };
            },
        }).then((result) => {
            if (!result.isConfirmed) {
                return;
            }
            self.saveDates(sheetId, result.value || {});
        });
    },

    saveDates(sheetId, dates) {
        const self = this;
        $.ajax({
            url: routeWithId(this.config.routes.dates, sheetId),
            method: 'PUT',
            data: {
                start_date: dates.start_date || '',
                due_date: dates.due_date || '',
                _token: csrfToken(),
            },
            success(response) {
                if (response && response.success && response.block) {
                    self.refreshNode(response.block);
                }
            },
            error(xhr) {
                const msg = (xhr.responseJSON?.errors?.due_date ? xhr.responseJSON.errors.due_date[0] : null)
                    || xhr.responseJSON?.message
                    || 'Impossibile salvare le date.';
                window.Swal && window.Swal.fire({ icon: 'error', title: 'Errore', text: msg });
            },
        });
    },

    confirmDeleteBlock(sheetId) {
        const self = this;
        const block = this.blocks[sheetId];
        if (!block || !this.canModify || !this.config.routes.destroy) {
            return;
        }

        const removeNode = function () {
            const nodeId = self.sheetToNode[sheetId];
            if (!nodeId) {
                return;
            }
            // Le connessioni vengono eliminate a cascata lato DB: evitiamo le DELETE ridondanti
            // scatenate da Drawflow durante la rimozione del nodo.
            self.suppressConnectionEvents = true;
            try {
                self.editor.removeNodeId('node-' + nodeId);
            } catch (e) {
                // ignore
            }
            self.suppressConnectionEvents = false;
        };

        if (!window.Swal) {
            removeNode();
            return;
        }

        window.Swal.fire({
            icon: 'warning',
            title: 'Eliminare il Working Block?',
            text: '"' + block.name + '" verra eliminato. I task collegati restano nel progetto senza Working Block.',
            showCancelButton: true,
            confirmButtonText: 'Elimina',
            cancelButtonText: 'Annulla',
            confirmButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                removeNode();
            }
        });
    },

    handleNodeRemoved(nodeId) {
        const self = this;
        const sheetId = this.nodeToSheet[nodeId];
        if (!sheetId) {
            return;
        }

        delete this.nodeToSheet[nodeId];
        delete this.sheetToNode[sheetId];

        Object.keys(this.connectionIds).forEach((key) => {
            const parts = key.split('->');
            if (parseInt(parts[0], 10) === sheetId || parseInt(parts[1], 10) === sheetId) {
                delete self.connectionIds[key];
            }
        });

        $.ajax({
            url: routeWithId(this.config.routes.destroy, sheetId),
            method: 'DELETE',
            data: { _token: csrfToken() },
            success() {
                delete self.blocks[sheetId];
                if (window.__taskSheetLabels) {
                    delete window.__taskSheetLabels[String(sheetId)];
                }
                if (window.__taskSheetsConfig && Array.isArray(window.__taskSheetsConfig.sheetIds)) {
                    window.__taskSheetsConfig.sheetIds = window.__taskSheetsConfig.sheetIds.filter((id) => id !== sheetId);
                }
            },
            error() {
                window.Swal && window.Swal.fire({
                    icon: 'error',
                    title: 'Errore',
                    text: 'Impossibile eliminare il Working Block. Ricarica la pagina e riprova.',
                });
            },
        });
    },

    divisionName(divisionId) {
        if (!divisionId) {
            return null;
        }
        const found = (this.availableDivisions || []).find((d) => String(d.id) === String(divisionId));
        return found ? found.name : null;
    },

    statusLabel(value) {
        const found = (this.statuses || []).find((s) => s.value === value);
        return found ? found.label : value;
    },

    addBlock() {
        const self = this;
        if (!this.config.canModify || !this.config.routes.store || !window.Swal) {
            return;
        }

        window.Swal.fire({
            title: 'Nuovo Working Block',
            input: 'text',
            inputPlaceholder: 'Nome Working Block',
            showCancelButton: true,
            confirmButtonText: 'Crea',
            cancelButtonText: 'Annulla',
            inputValidator: (value) => {
                if (!value || !value.trim()) {
                    return 'Inserisci un nome';
                }
                return null;
            },
        }).then((result) => {
            if (!result.isConfirmed || !result.value) {
                return;
            }
            $.ajax({
                url: self.config.routes.store,
                method: 'POST',
                data: { name: result.value.trim(), _token: csrfToken() },
                success(response) {
                    if (!response || !response.success) {
                        return;
                    }
                    self.addBlockNode(response.block || response.sheet);
                },
                error(xhr) {
                    const msg = (xhr.responseJSON?.errors?.name ? xhr.responseJSON.errors.name[0] : null)
                        || xhr.responseJSON?.message
                        || 'Errore durante la creazione del Working Block';
                    window.Swal.fire({ icon: 'error', title: 'Errore', text: msg });
                },
            });
        });
    },

    addBlockNode(sheet) {
        const status = sheet.status || 'in_attesa';
        const divisionId = sheet.division_id || null;
        const block = {
            id: sheet.id,
            name: sheet.name,
            status: status,
            status_label: sheet.status_label || this.statusLabel(status),
            canvas_x: null,
            canvas_y: null,
            task_count: sheet.task_count || 0,
            division_id: divisionId,
            division_name: sheet.division_name || this.divisionName(divisionId),
            start_date: sheet.start_date || null,
            start_date_label: sheet.start_date_label || null,
            due_date: sheet.due_date || null,
            due_date_label: sheet.due_date_label || null,
        };
        this.blocks[block.id] = block;

        const count = Object.keys(this.sheetToNode).length;
        const posX = 60 + (count % 5) * 280;
        const posY = 80 + Math.floor(count / 5) * 200;

        const nodeId = this.editor.addNode(
            'working_block',
            1,
            1,
            posX,
            posY,
            'working-block',
            { sheetId: block.id },
            this.buildNodeHtml(block),
            false
        );

        this.sheetToNode[block.id] = nodeId;
        this.nodeToSheet[nodeId] = block.id;
        this.persistPosition(nodeId);

        // Mantieni allineate le strutture usate dalla griglia (best-effort, senza reload).
        if (window.__taskSheetLabels) {
            window.__taskSheetLabels[String(block.id)] = block.name;
        }
        if (window.__taskSheetsConfig && Array.isArray(window.__taskSheetsConfig.sheetIds)) {
            window.__taskSheetsConfig.sheetIds.push(block.id);
        }
    },
};

module.exports = WorkingBlocksCanvas;
